import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useCallback } from "react";

interface ICrewSchedTooltipToggleProps {
  crewScheduleHideTooltips: boolean;
  setCrewScheduleHideTooltips: React.Dispatch<React.SetStateAction<boolean>>;
}

const CrewSchedTooltipToggle = (props: ICrewSchedTooltipToggleProps): JSX.Element => {
  const { crewScheduleHideTooltips, setCrewScheduleHideTooltips } = props;

  const handleChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newVal: boolean) => {
      setCrewScheduleHideTooltips(newVal);
    },
    [setCrewScheduleHideTooltips]
  );

  return (
    <ToggleButtonGroup value={crewScheduleHideTooltips ?? false} exclusive onChange={handleChange}>
      <ToggleButton value={true}>Hide</ToggleButton>
      <ToggleButton value={false}>Show</ToggleButton>
    </ToggleButtonGroup>
  );
};

export { CrewSchedTooltipToggle };
